export const customDarkTheme = {
    dark: true,
    colors: {
        primary: "#3a6a93",
        secondary: "#e4d8c4",
        background: "#181818"
    }
}

export const customLightTheme = {
    dark: false,
    colors: {
        primary: "#3a6a93",
        secondary: "#e4d8c4"
    }
}